<template>
  <div>
    <CategoryBanner :id="id" />
    <div class="container-fluid bg-white trent pt-5 pb-5">
      <h4>{{ id }}</h4>
      <div class="underline-green"></div>
      <div class="boxes">
        <ProductCard v-for="product in products" :key="product.id" :product="product" />
      </div>
    </div>
    <!-- SHOW LOADING -->
    <LoadingComponent v-if="loading" />
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard";
import CategoryBanner from "../components/CategoryBanner";
import LoadingComponent from "../components/LoadingComponent";
export default {
  name: "Categorylist",
  components: {
    ProductCard,
    CategoryBanner,
    LoadingComponent
  },
  props: ["id"],
  computed: {
    // GET PRODUCT BY CATEGORY USING THE ID FROM PARAMS
    products() {
      let productId = this.id;
      return this.$store.getters.productByCategory(productId);
    }
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    // PROCESS LOADING
    processLoading: function() {
      this.loading = true;
      this.$store.state.showSearch = true;
      setTimeout(() => this.closeLoading(), 2000);
    },
    // CLOSE LOADING
    closeLoading: function() {
      if (this.loading) {
        this.loading = false;
        this.$store.state.showSearch = false;
      }
    }
  },
  mounted() {
    this.processLoading();
  },
  watch: {
    "$route.params.id": function(id) {
      console.log(id);
      this.processLoading();
    }
  }
};
</script>

<style></style>
